<template>
  <Table
    id="exportable_data"
    v-if="$store.getters.getPrintDailySummaryWiseCountList.length"
  >
    <template v-slot:header>
      <tr>
        <td class="font_detail">SL</td>
        <td class="font_detail">Counterman Name</td>
        <td class="font_detail">Summary Report Date</td>

        <td class="font_detail">Print Count</td>
      </tr>
    </template>
    <template v-slot:body>
      <tr v-for="(item, index) in PrintDailySummaryWiseCountList" :key="index">
        <td class="font_detail">{{ index + 1 }}</td>
        <td class="font_detail">
          {{ item.counterman[0] }}
        </td>
        <td class="font_detail">
          {{ dateFormat(item.summaryDate) }}
        </td>

        <td class="font_detail">
          {{ item.printCount }}
        </td>
      </tr>
      <!-- <tr class="bg-dark text-white"  >
        <td class="font_detail"></td>
        <td class="font_detail"></td>
        <td class="font_detail"></td>
        <td class="font_detail"></td>
        <td class="font_detail"></td>
        <td class="font_detail"></td>
      </tr> -->
    </template>
    <!-- <template v-slot:pagination>
      <Pagination
        v-model="shipWiseSeatReport.page"
        :records="$store.getters.getShipWiseSeatDetailsOwner.length"
        :per-page="shipWiseSeatReport.limit"
        @paginate="getSeatDetails"
        :options="options"
      />
    </template> -->
  </Table>
</template>

<script>
import { computed } from "vue";
import moment from "moment";
import store from "@/store";
export default {
  name: "tripWiseTicketPrintCountDetails",
  setup() {
    const dateFormat = (date) => {
      return moment(String(date)).utcOffset(6, false).format("DD-MMM-yyyy");
    };
    const PrintDailySummaryWiseCountList = computed(() => {
      return store.getters.getPrintDailySummaryWiseCountList.filter(
        (item) => item.printCount > 1
      );
    });
    return {
      dateFormat,
      PrintDailySummaryWiseCountList,
    };
  },
};
</script>

<style>
</style>